import styled from "styled-components";

export const FormContainer = styled.div`
	.form {
		justify-content: center;
		padding: 20px;
	}
	.custom-select {
		z-index: 999;
		padding: 20px 0px;
		justify-content: center;
		align-items: center;
		width: 100%;
		flex: 1;
	}
	.label-title{
		font-weight: 800;
	}
	.label-title-second {
		color: #666666;
		padding: 5px 0px;
	}
	.contact-input{
		padding-top: 10px;
	}
	@media only screen and (min-width: 1025px) {
		.custom-select {
			max-width: 41.2rem;
			position: fixed;
		}
	}

	@media only screen and (min-width: 768px) and (max-width: 1024px) {
		.custom-select {
			max-width: 41rem;
			position: fixed;
		}
	}

	@media only screen and (min-width: 641px) and (max-width: 767px) {
		.custom-select {
			position: relative;
		}
	}

	@media only screen and (max-width: 640px) {
		.custom-select {
			position: relative;
		}
	}
`;
